module.exports = __webpack_public_path__ + "static/img/guanlibanner.d120d57f.png";